const cloudflarePhoto = require('./cloudflarePhoto')
const fullPhoto = require('./fullPhoto')

module.exports = function offerPhoto(offer, order, defaultVariant) {
	const { tracking } = offer || {}
	const { pid, cloudflare } = tracking || {}
	const { mainPhoto, photos = [] } = cloudflare || {}

	if (mainPhoto || (photos && photos.length))
		return cloudflarePhoto(
			photos[order] || mainPhoto,
			defaultVariant || 'x1grid',
		)
	if (pid) return fullPhoto(pid, order)
	return ''
}
